import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal, TextInput } from "flowbite-react"
import { FiPlusSquare } from "react-icons/fi";
import { HiOutlineBackspace, HiOutlineSearch, HiOutlinePlus } from "react-icons/hi";
import { getProductForMenuEdit } from '../../redux/productReducer';
import { openSnackBar } from '../../redux/snackBarReducer';
import swal from 'sweetalert2';
import AddProductItem from "./AddProductItem";
import { useTranslation } from "react-i18next";

function AddProductsModal(props) {
    const { t } = useTranslation();
    const { globalState, productState } = useSelector((state) => state);
    // const { id, company, name } = userInfo;
    const { count, active_count, inactive_count, productsForMenuEdit } = productState;

    const dispatch = useDispatch();
    const type_string = ["active", "inactive", "global"];
    const [modalShow, setModalShow] = useState(false);    //modal modalShow hide
    const [search, setSearch] = useState("");   //search bar text 
    const [selectTab, setSelectTab] = useState(0);
    const [selectedProducts, setSelectedProducts] = useState([]);

    useEffect(() => {
        dispatch(getProductForMenuEdit({
            product_name: search, type: type_string[selectTab], company: globalState.menuCondition.company,
            isGlobal: globalState.menuCondition.isGlobal, user_id: globalState.menuCondition.user_id, role: globalState.menuCondition.role
        }));
        // dispatch(getProductForMenuEdit({ product_name: search, type: "active" }));
    }, [search, selectTab])

    var activeStyle = "flex items-center justify-center p-4 text-sm font-medium first:ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500 base active text-blue-600 rounded-t-lg border-b-2 border-indigo-500 active dark:text-blue-500 dark:border-sitebg-300";
    var inactiveStyle = "flex items-center justify-center p-4 text-sm font-medium first:ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500 base active border-b-2 border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300";

    const changeSearch = (e) => {
        setSearch(e.target.value);
        // dispatch(getProductForMenuEdit({ product_name: search, type: type_string[selectTab] }));
    }

    const addProducts = () => {
        if (selectedProducts?.length > 0) {
            props.addProducts(selectedProducts);
            close();
        } else {
            dispatch(openSnackBar({ message: t("msg_select_product_for_menu"), status: 'error' }));
        }
    }

    const closeModal = () => {
        swal.fire({
            title: t("swal_are_you_sure"),
            text: t("swal_leave_page"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("swal_leave")
        })
            .then(result => {
                if (result.isConfirmed) {
                    close();
                }
            });

    }

    function close() {
        setModalShow(false);
        setSearch("");
        setSelectedProducts([]);
    }

    const selectState = (value) => {
        setSelectTab(value);
        // dispatch(getProductForMenuEdit({ product_name: search, type: type_string[selectTab] }));
    }

    const removeProduct = (pos) => {
        setSelectedProducts(selectedProducts.splice(pos, 1))
    }

    const addProduct = (data) => {
        setSelectedProducts([...selectedProducts, data])
    }

    return (
        <>
            <div>
                <Button color="red" onClick={() => setModalShow(true)} outline={false} className=" mr-2 bg-indigo-500 hover:!bg-indigo-400 text-white" >
                    {/* <FiPlusSquare className="mr-2 h-6 w-6 text-sitebg-50" /> */}
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" className="mr-2 h-5 w-5 text-sitebg-50" x="0px" y="0px"
                        viewBox="0 0 24 24" >
                    <path className="st0" d="M22.4,17.4l-5,5c-0.6,0.6-1.3,0.9-2.1,0.9H3.8c-1.7,0-3-1.3-3-3V3.8c0-1.7,1.3-3,3-3h16.5c1.7,0,3,1.3,3,3l0,0
                        v11.5C23.3,16.1,22.9,16.8,22.4,17.4z"/>
                    <path className="st0" d="M15.8,23.2v-4.5c0-1.7,1.3-3,3-3h4.5"/>
                    <line className="st0" x1="12" y1="7.5" x2="12" y2="16.5"/>
                    <line className="st0" x1="7.5" y1="12" x2="16.5" y2="12"/>
                    </svg>
                    {t("add_product")}
                </Button>
            </div>
            <Modal
                show={modalShow}
                size="4xl"
                popup={true}
                onClose={() => closeModal()}
            >
                <Modal.Header className="px-6 py-5">
                    {t("add_product")}
                </Modal.Header>
                <hr />
                <Modal.Body className="overflow-y-auto" style={{ maxHeight: "70vh" }}>
                    <div className="py-6">
                        <TextInput
                            id="searchmenu"
                            type="search"
                            sizing="md"
                            placeholder={t("what_are_looking")}
                            required={true}
                            icon={HiOutlineSearch}
                            value={search}
                            onChange={(e) => changeSearch(e)}
                        />
                    </div>

                    <div aria-label="Tabs with underline" role="tablist" className="col-span-3 flex text-center flex-wrap -mb-px  pl-8">
                        <button
                            onClick={() => selectState(0)}
                            type="button"
                            className={selectTab === 0 ? activeStyle : inactiveStyle}
                        >
                            <div className="flex text-indigo-500 gap-4">
                                {t("active")}
                                <div className="bg-indigo-500 text-white px-2 rounded-full">
                                    {active_count}
                                </div>
                            </div>
                        </button>
                        <button
                            onClick={() => selectState(1)}
                            type="button"
                            className={selectTab === 1 ? activeStyle : inactiveStyle}
                        >
                            <div className="flex text-indigo-500 gap-4">
                                {t("inactive")}
                                <div className="bg--indigo-500 text-white px-2 rounded-full">
                                    {inactive_count}
                                </div>
                            </div>
                        </button>
                        <button
                            onClick={() => selectState(2)}
                            type="button"
                            className={selectTab === 2 ? activeStyle : inactiveStyle}
                        >
                            <div className="flex text-indigo-500 gap-4">
                                {t("global")}
                                <div className="bg-indigo-500 text-white px-2 rounded-full">
                                    {count}
                                </div>
                            </div>
                        </button>
                    </div>

                    {productsForMenuEdit?.length > 0 && productsForMenuEdit.map((data, index) =>
                        <AddProductItem key={index} data={data} selectedProducts={selectedProducts} removeProduct={removeProduct} addProduct={addProduct} />
                    )
                    }
                </Modal.Body>
                <hr />
                <Modal.Footer>
                    <div className="flex items-center gap-4 m-auto">
                        <div>
                            <Button onClick={() => closeModal()} color="red" className="bg-white bg-opacity-0 text-gray-400 border-2 border-gray-200">
                                <HiOutlineBackspace className="mr-2 h-5 w-5" />
                                {t("deselect_all_products")}
                            </Button>
                        </div>
                        <div>
                            <Button onClick={() => addProducts()} color="red" className="bg-indigo-500 text-white hover:!bg-indigo-400" >
                                {/* <HiOutlinePlus className="mr-2 h-6 w-6 text-sitebg-50" /> */}
                                <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 h-5 w-5 text-white" viewBox="0 0 24 24" stroke-width="1.5px">                                    
                                <defs/><title>add-square</title><line x1="12" y1="7.5" x2="12" y2="16.5" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                <line x1="7.5" y1="12" x2="16.5" y2="12" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="3" ry="3" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                {t("add_selected_product_to_menu")}
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddProductsModal;
